var map = {
	"./LoldocupEvent.vue": [
		8284,
		836,
		8284
	],
	"./LoldocupIntro.vue": [
		82628,
		836,
		8414,
		2628
	],
	"./LoldocupResult.vue": [
		52282,
		836,
		2282
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76330;
module.exports = webpackAsyncContext;